import React from "react";
import ReworkProductList from "../../../components/user/reworkProduct/reworkProductFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const ReworkProductListPage = (props) => {
  return <Layout body={<ReworkProductList />} />;
};

ReworkProductListPage.propTypes = {};

export default ReworkProductListPage;
